/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Account_DescriptionInputs */

const en_settings_account_description = /** @type {(inputs: Settings_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access your account details.`)
};

const es_settings_account_description = /** @type {(inputs: Settings_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accede a los detalles de tu cuenta.`)
};

/**
* | output |
* | --- |
* | "Access your account details." |
*
* @param {Settings_Account_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_account_description = /** @type {((inputs?: Settings_Account_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Account_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_account_description(inputs)
	return en_settings_account_description(inputs)
});